<template>
  <label
    :class="[
      {
        'opacity-50 cursor-not-allowed': disabled,
        'checkbox--checked': isChecked,
        'cursor-pointer': $attrs['data-label'],
      },
    ]"
    class="checkbox relative flex items-top select-none"
  >
    <input
      v-model="isChecked"
      :disabled="disabled"
      v-bind="$attrs"
      class="absolute opacity-0 border-0"
      tabindex="0"
      type="checkbox"
      v-on="listeners"
    />
    <div class="text-sm text-grey-575 leading-tight flex items-center flex-grow">
      <div
        class="checkbox__indicator relative bg-white mr-3 w-5 h-5 border
        border-grey-400 rounded flex-none cursor-pointer hover:border-blue-600"
      />
      <span v-if="$attrs['data-label']">{{ $attrs['data-label'] }}</span>
      <slot v-else />
    </div>
  </label>
</template>

<script>
export default {
  inheritAttrs: false,
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    value: {
      type: [String, Number, Boolean],
      default: '',
    },
    checked: {
      type: [Array, Boolean],
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isChecked: false,
    }
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        change: () => {
          if (this.checked.constructor === Array) {
            const updated = this.checked
            if (this.isChecked) {
              updated.push(this.value)
            } else {
              const index = updated.indexOf(this.value)
              if (index > -1) updated.splice(index, 1)
            }
            this.$emit('change', updated)
          } else {
            this.$emit('change', this.isChecked)
          }
        },
      }
    },
  },
  watch: {
    checked: {
      handler() {
        this.isChecked = this.checked.constructor === Array ? this.checked.includes(this.value) : this.checked
      },
      immediate: true,
    },
  },
}
</script>

<style>
.checkbox input {
  z-index: -1;
}

.checkbox__indicator {
  transition: background-color 0.3s;
}

.checkbox--checked .checkbox__indicator {
  @apply border-0 bg-blue-500;
}

.checkbox.cursor-pointer:hover .checkbox__indicator,
.checkbox.cursor-pointer:focus .checkbox__indicator {
  @apply border-blue-600;
}

.checkbox__indicator::after {
  content: '';
  display: none;
  position: absolute;
  top: 3px;
  left: 7px;
  width: 6px;
  height: 11px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transition: border-width 0.3s;
  transform: rotate(45deg);
}

.checkbox--checked .checkbox__indicator::after {
  @apply block;
}

</style>

<docs>
This is a transparent component of `<input type="checkbox">`

```vue
<DrInputCheckbox data-label="This is a test" />
```
</docs>